import { aspectRatioConfig } from './aspect-ratio-config';

export const getEditorTitle = (i18n, imageType, isLogo = false) => {
  let titleKey = isLogo ?
    _TL_('Edit logo') : _TL_('Edit image');
  let subTitle = null;

  if (imageType) {
    titleKey = aspectRatioConfig[imageType].editorTitle(isLogo);
    subTitle = isLogo ?
      i18n.getString(_TL_('Choose how your logo will look with this ad placement.')) :
      i18n.getString(_TL_('Choose how your image will look with this ad placement.'));
  }

  return [i18n.getString(titleKey), subTitle];
};
